import { Heading } from "@planningcenter/doxy-web"
import { css } from "@emotion/react"
import { Link } from "react-router-dom"
import { Icon } from "source/shared/components"
import RecurringDonationsList from "./RecurringDonationsList"
import PledgesList from "./PledgesList"
import { Suspense } from "react"
import { Loading } from "source/giving/donate/form/components/Loading"
import { NotifyNativeLoaded } from "source/shared/hooks/useNotifyNativeLoaded"
import NativeHeader from "source/shared/NativeHeader"

export default function PlannedGivingContent() {
  return (
    <>
      <NativeHeader title="Planned giving" />
      <section>
        <div className="d-f fd-c g-2">
          <div className="d-n d-f@md">
            <Heading level={1} size={2} text="Planned giving" />
          </div>
          <div
            className="d-f fd-c p-2 g-2"
            css={css`
              border: 1px solid var(--color-tint6);
              border-radius: 8px;
            `}
          >
            <div className="d-f jc-sb ai-c">
              <Heading level={2} size={3} text="Recurring donations" />
              <Link
                to="/giving?recurring=true"
                className="btn outline-btn sm-btn d-f g-1"
              >
                <Icon
                  symbol="general#plus"
                  aria-hidden="true"
                  css={css`
                    height: 12px;
                    width: 12px;
                  `}
                />
                New
              </Link>
            </div>
            <Suspense fallback={<Loading />}>
              <NotifyNativeLoaded />
              <RecurringDonationsList showFullDetails={true} />
            </Suspense>
            <Link to="/me/profile/payment-methods" className="fs-13 fw-500">
              Manage payment methods
            </Link>
          </div>
          <Suspense fallback={<Loading />}>
            <PledgesList showFullDetails={true} />
          </Suspense>
        </div>
      </section>
    </>
  )
}
